import { AccountContactMergeData, AccountContactMergeSchema } from '../data/account.contact.merge.data';
import { AccountMergeData, AccountMergeSchema } from '../data/account.merge.data';
import { AllocationArrayMergeData, AllocationArrayMergeSchema } from '../data/allocation.merge.data';
import { AttachmentsMergeData, AttachmentsMergeSchema } from '../data/activity.merge.data';
import { CompanyMergeData, CompanyMergeSchema } from '../data/company.merge.data';
import { EmployeeMergeData, EmployeeMergeSchema } from '../data/employee.merge.data';
import { JobSiteMergeData, JobSiteMergeSchema } from '../data/job.site.merge.data';
import { OpportunityMergeData, OpportunityMergeSchema } from '../data/opportunity.merge.data';
import { TaskArrayMergeData, TaskArrayMergeDataSchema } from '../data/task.merge.data';
import { TimesheetArrayMergeData, TimesheetArrayMergeDataSchema } from '../data/timesheet.merge.data';
import { ActivityEntityName } from '../../../../entities/shared/activity.entity.name';
import { MergeDataset } from '../../decorators/decorators/merge.dataset';
import { MergeSource } from '../../decorators/decorators/merge.source';

@MergeDataset({
    entity: ActivityEntityName.Opportunity
})
export class OpportunityMergeDataset {

    @MergeSource({
        schema: OpportunityMergeSchema
    })
    opportunity: OpportunityMergeData;

    @MergeSource({
        schema: AccountMergeSchema
    })
    opportunityAccount: AccountMergeData;

    @MergeSource({
        schema: AccountContactMergeSchema
    })
    opportunityContact: AccountContactMergeData;

    @MergeSource({
        schema: JobSiteMergeSchema
    })
    opportunitySite: JobSiteMergeData;

    @MergeSource({
        schema: EmployeeMergeSchema
    })
    opportunityOwner: EmployeeMergeData;

    @MergeSource({
        schema: CompanyMergeSchema
    })
    opportunityCompany: CompanyMergeData;

    @MergeSource({
        schema: AttachmentsMergeSchema,
        ignoreCustomFields: true,
    })
    opportunityFiles?: AttachmentsMergeData;

    @MergeSource({
        schema: TaskArrayMergeDataSchema,
        ignoreCustomFields: true,
    })
    opportunityTasks: TaskArrayMergeData;

    @MergeSource({
        schema: TimesheetArrayMergeDataSchema,
        ignoreCustomFields: true,
    })
    opportunityTimesheets: TimesheetArrayMergeData;

    @MergeSource({
        schema: AllocationArrayMergeSchema,
        ignoreCustomFields: true,
    })
    opportunityAppointments: AllocationArrayMergeData;


    public static get empty() {
        return {
            opportunity: new OpportunityMergeData(),
            opportunityAccount: new AccountMergeData(),
            opportunityContact: new AccountContactMergeData(),
            opportunitySite: new JobSiteMergeData(),
            opportunityOwner: new EmployeeMergeData(),
            opportunityCompany: new CompanyMergeData()
        } as OpportunityMergeDataset;
    }

}